module.exports = __webpack_public_path__ + "img/caba_summer.e9337aef.svg";